export const DEFAULT_TYPE = '__DEFAULT_TYPE__';

export const META_FIELD = '__META__'; // Note: Hardcoded in interfaces/IRawModel

export const DATX_META: unique symbol = Symbol.for('datx administration');
